export const common = {
    email: {
        type: 'string',
        length: { minimum: 1, maximum: 65 },
        presence: { allowEmpty: false },
    },
};

export const travelAgentDataRules = {
    first_name: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    last_name: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    country_code: {
        type: 'string',
        length: { minimum: 1, maximum: 5 },
        presence: { allowEmpty: false },
    },
    phone: {
        type: 'string',
        length: { minimum: 10, maximum: 20 },
        presence: { allowEmpty: false },
    },
    address: {
        type: 'string',
        length: { minimum: 1, maximum: 120 },
        presence: { allowEmpty: false },
    },
    city: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    state: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    country: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    zip: {
        type: 'string',
        length: { minimum: 3, maximum: 12 },
        presence: { allowEmpty: false },
    },
};
